// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Aufgabe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SetActiveAufgabeInboundPromptQuery = { promptId: string };

export function useSetActiveAufgabeInboundPrompt(): (
  aufgabeId: string,
  query: SetActiveAufgabeInboundPromptQuery
) => Promise<Aufgabe> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, query) =>
      (await getAPI()).prompts.setActiveAufgabeInboundPrompt({
        aufgabeId,
        ...query,
      }),
    [getAPI]
  );
}
